import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers, profile } from "../../slices/userSlice"; // Supondo que tenha uma action para isso.
import { uploads } from "../../utils/config";
import avatarDefault from "../../assets/images/avatarDefault.webp";

const Ranking = () => {
  const dispatch = useDispatch();
  const { users = [], loading, error } = useSelector((state) => state.user);
  const { user } = useSelector((state) => state.user);

  useEffect(() => {
    const fetchData = async () => {
      await dispatch(profile());
      await dispatch(getAllUsers()); // Aciona a action para buscar os usuários.
    };

    fetchData();
  }, [dispatch]);

  if (loading) return <p>Carregando ranking...</p>;
  if (error) return <p>Erro: {error}</p>;

  // Verificar se o usuário está no ranking e sua posição
  const userPosition = users.findIndex(u => u._id === user?._id) + 1;
  
  return (
    <div className="min-h-dvh relative mt-16">
    <div className="bg-verde-oliva border-verde-musgo bg-opacity-85 px-6 mt-20 pt-4 sm:mx-auto sm:max-w-lg max-w-3xl sm:rounded-lg">
      <h2 className="text-2xl font-bold mb-4 text-center ranking-header">Ranking Atual</h2>
      <table className="w-full table-auto border-collapse ranking-table">
        <thead>
          <tr className="text-yellow-300 text-lg">
            <th className="px-4 py-2 text-left">Posição</th>
            <th className="px-4 py-2 text-left">Jogador</th>
            <th className="px-4 py-2 text-right">Pontuação</th>
          </tr>
        </thead>
        <tbody>
          {users.slice(0, 50).map((user, index) => (
            <tr
              key={user._id}
              className={`${
                index === 0
                  ? "bg-yellow-400 text-black"
                  : index === 1
                  ? "bg-gray-400 text-black"
                  : index === 2
                  ? "bg-bronze-400 text-black"
                  : (user._id === user._id ? "bg-blue-500 text-white" : "bg-gray-700")
              } bg-opacity-85 hover:bg-gray-600 transition text-white`}
            >
              <td className="px-4 py-2 font-bold">{index + 1}</td>
              <td className="px-4 py-2 flex items-center">
                <img
                  src={user.profileImage ? `${uploads}/users/${user.profileImage}` : avatarDefault}
                  alt={user.nickname || user.name}
                  className="w-8 h-8 rounded-full mr-2 user-avatar"
                />
                <span>{user.nickname || user.name}</span>
              </td>
              <td className="px-4 py-2 text-right font-semibold points">
                {user.actualScore}
              </td>
            </tr>
          ))}

          {/* Se o jogador atual estiver além do top 50, exibe uma linha de elipse */}
          {userPosition > 50 && userPosition > 100 && (
            <tr>
              <td colSpan="3" className="text-center">...</td>
            </tr>
          )}

          {/* Exibe o jogador atual se ele não estiver no Top 50 */}
          {userPosition > 50 && (
            <tr className="bg-blue-500 text-white">
              <td className="px-4 py-2 font-bold">{userPosition}</td>
              <td className="px-4 py-2 flex items-center">
                <img
                  src={user.profileImage ? `${uploads}/users/${user.profileImage}` : avatarDefault}
                  alt={user.nickname || user.name}
                  className="w-8 h-8 rounded-full mr-2"
                />
                <span>{user.nickname || user.name}</span>
              </td>
              <td className="px-4 py-2 text-right font-semibold points">
                {user.actualScore}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    </div>
  );
};

export default Ranking;
